<template>
  <div id="Contact">
    <Header msg="/contact" />
	<div id='contactPage'>
		<div class='bannerBox' :style="{backgroundImage:'url('+require('@/assets/about/contact.jpg')+')'}"></div>
		<div class='contactBox'>
			<div class='contactName'>联系我们</div>
			<div class='contactTitle'>如有相关疑问，请留言与橘袋联系</div>
			<input type="text" v-model="name" placeholder="您的姓名" class='nameIn' />
			<input type="text" v-model="mail" placeholder="您的邮箱" class='mailIn' />
			<textarea v-model="talk" placeholder="您想说的话" class='talkIn' maxlength="500"  />
			<div class='contactBtn' @click='inContact' style='cursor:pointer;' :style='showPost?"background:#eee":""'>{{showPost?"已提交":"提交"}}</div>
		</div>
	
	</div>
    <Foot />
  </div>

</template>

<script>
// @ is an alias to /src
import Header from '@/components/header.vue'
import Foot from '@/components/foot.vue'
export default {
  name: 'Contact',
  components: {
      Header,
      Foot
  },
  data:()=>{
  	return{
  		name:"",
  		mail:"",
  		talk:"",
  		showPost:false,
  	}
  },

  methods:{
	inContact(){
		let that = this
		 this.axios({
            method: 'post',
            url:"/index/contact",
            data: {
              name:this.name,
              mailbox:this.mail,
              content:this.talk,
            }
          }).then(res=>{
          		that.name=""
				that.mail=""
				that.talk=""
				that.showPost=true
          })	
	}
  },
  mounted:function(){
 
  	 $('html,body').animate({scrollTop:0},10);
  },
}
</script>
<style>
#Contact{
	width: 100%;
	height:100%;
}
#contactPage{

}
.bannerBox{
	width: 100%;
	height:640px;
	background-repeat: no-repeat;
	  background-size: 100%;
	  background-position:center;
	  -moz-background-size: 100% 100%;
}
.contactBox{
	width: 620px;
	height:540px;
	margin:70px auto 120px;
	overflow: hidden;
}
.contactName{
	text-align:center;
	height:42px;
	font-size:30px;
	font-family:PingFangSC-Medium;
	font-weight:600;
	color:rgba(194,94,77,1);
	line-height:42px;
	letter-spacing:1px;
	margin:29px 0 17px;
}
.contactTitle{
	text-align:center;
	height:30px;
	font-size:24px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(20,20,20,1);
	line-height:33px;
	letter-spacing:1px;
	margin-bottom: 50px;
}
.contactBox input{
	display: block;
	width:520px;
	background:rgba(249,249,250,1);
	margin:0 auto 10px;
	outline: none;
	border: 0;
	padding: 15px 13px;
	font-size: 16px;

}
.nameIn{
	height:48px;
}

.mailIn{
	height:48px;
}
.talkIn{
    height:140px;
    display: block;
	width:520px;
	background:rgba(249,249,250,1);
	margin:0 auto 20px;
	outline: none;
	border: 0;
	padding: 15px 13px;
	font-size: 16px;
	resize: none;
}

.contactBox input::-webkit-input-placeholder{
        color: #BBB;
}
.contactBox input::-moz-placeholder{ 
        color: #BBB;        
}
.contactBox input::-ms-input-placeholder{ 
        color: #BBB;       
}
.contactBox textarea::-webkit-input-placeholder{
        color: #BBB;
}
.contactBox textarea::-moz-placeholder{ 
        color: #BBB;        
}
.contactBox textarea::-ms-input-placeholder{ 
        color: #BBB;       
}

.contactBtn{
	width:520px;
	height:48px;
	line-height: 48px;
	background:rgba(194,94,77,1);
	font-size:16px;
	font-family:PingFangSC-Medium;
	font-weight:500;
	color:rgba(255,255,255,1);
	letter-spacing:1px;
	margin:0 auto;
	display: block;
}

</style>